import { useQuery } from "@tanstack/react-query";
import type { QueryOpts } from "~api/helpers";
import type { TimeWorked } from "~generated";
import { TimeWorkedService } from "~generated";
import { timeEntriesKeys } from "./timeEntries";

const timeWorkedKeys = {
  base: () => [...timeEntriesKeys.base(), "timeWorked"] as const,
  me: () => [...timeWorkedKeys.base(), "me"] as const,
};

export function useTimeWorked(
  options?: QueryOpts<TimeWorked, ReturnType<typeof timeWorkedKeys.me>>,
) {
  return useQuery({
    ...options,
    queryKey: timeWorkedKeys.me(),
    queryFn: async () =>
      (await TimeWorkedService.getMyTimeWorked())?.time_worked,
  });
}
